var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmokingAllowed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.563,
  clipPath: "url(#smokingAllowed_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.008 23.008H7.07v-5.313h15.938a1.33 1.33 0 0 1 1.328 1.328v2.657a1.33 1.33 0 0 1-1.328 1.328M17.695 17.695v5.313M4.414 17.695v5.313M11.055 5.742A3.984 3.984 0 0 1 7.07 9.727a2.656 2.656 0 0 0-2.656 2.656M15.04 5.742a7.97 7.97 0 0 1-7.97 7.969"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "smokingAllowed_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.75 3.75H25V25H3.75z"
})))));
export default SvgSmokingAllowed;